import { InferType, bool, object, string } from 'yup';
import { AiDateSchema } from './AiDateSchema';

export const AiCareDocumentWorkDetailsSchema = object().shape({
  jobTitle: string().nullable().notRequired(),
  dateSignedOff: AiDateSchema,
  workPattern: string().nullable().notRequired(),
  hideHopingToReturnToWorkIn: bool().nullable().notRequired(),
  hopingToReturnToWorkIn: string().nullable().notRequired(),
});

export type AiCareDocumentWorkDetails = InferType<
  typeof AiCareDocumentWorkDetailsSchema
>;
